import { SETTINGS_TRUE_VALUE } from '@spike/marketplace-model';
import { useMemo } from 'react';
import { useAuth } from './useAuth';
import { useMarketplace } from './useMarketplace';

type MarketplaceWithSettings = {
    id?: number | string;
    settings?: Array<{ key: string; value: string }>;
};

export const isAiAgentEnabled = (marketplace?: MarketplaceWithSettings | null): boolean =>
    marketplace?.settings?.find(s => s.key === 'ai_agent')?.value === SETTINGS_TRUE_VALUE;

export const useAiAgentEnabled = (): boolean => {
    const marketplace = useMarketplace();
    return isAiAgentEnabled(marketplace);
};

export const useAiAgentTalkUrl = (): string => {
    const auth = useAuth();
    const marketplace = useMarketplace();

    return useMemo(() => {
        const user = auth.user as (typeof auth.user & { access_token?: string }) | undefined;
        const accessToken = user?.access_token ?? auth.token ?? '';
        const params = new URLSearchParams({
            marketplace_id: String(marketplace.id),
            access_token: accessToken
        });
        return `${process.env.REACT_APP_HOST_URL}${process.env.REACT_APP_WEB_BASE_URL}talk?${params.toString()}`;
    }, [auth.user, auth.token, marketplace.id]);
};
